import { useState } from 'react'
import type { Item } from 'typings'
import { useFetch } from './useFetch'
import { assertFulfilled } from './utils'

type CategoryResponse = {
  Id: number
  Name: string
}

export function useCategoriesImport() {
  const [loading, setLoading] = useState(false)

  const { fetcherWrapper } = useFetch()

  function getCategory(id: string): Promise<Item> {
    const url = new URL(
      `/api/proxy/catalog/pvt/category/${id}`,
      window.location.origin
    )

    return fetcherWrapper(url)
      .then((r) => {
        if (r.status === 404) return Promise.reject('Not found')
        if (!r.ok) return Promise.reject('Error retrieving categories')

        return r.json()
      })
      .then((response: CategoryResponse) => ({
        id: response.Id.toString(),
        name: response.Name,
      }))
  }

  async function importCategories(
    ids: string[]
  ): Promise<{ items: Item[]; found: number; notFound: number }> {
    setLoading(true)

    const promises = ids.map((id) => getCategory(id))

    const categories = await Promise.allSettled(promises).then((resuls) => {
      return resuls.filter(assertFulfilled).map((r) => r.value)
    })

    setLoading(false)

    return {
      found: categories.length,
      notFound: categories.length - categories.length,
      items: categories,
    }
  }

  return { importCategories, loading }
}
